import { observer } from 'mobx-react';
import React from 'react';
import { Redirect, Switch, withRouter } from 'react-router-dom';
import { ModuleType } from '../../constants/enums/module-type-enum';
import {
  findRouteAccess,
  redirectToDefaultRoute,
} from '../../helpers/route-helper';
import {
  AccountActivation,
  ActiveTrayManagement,
  AIMSPortal,
  BaseUser,
  FactoryAccess,
  FactoryManagement,
  FactorySchedule,
  GroupManagement,
  HKRDashboardData,
  KishuManagement,
  Login,
  OperatorAssignTask,
  OrderTableView,
  ProcessManagement,
  ProcessTemplateManagement,
  ProductManagement,
  TagAssignRemove,
  TeplarPrint,
  TrayManagement,
  UserLogs,
  DimensionTableFields,
  CheckItemTemplate,
  TrayTagReassignment,
  BomSearch,
} from '../../modules';
import ProcessWiseChart from '../../modules/active-tray-mgmt/process-wise-chart';
import OperatorImageAssign from '../../modules/operator/operatorImageAssign';
import OperatorListDetail from '../../modules/operator/OperatorListDetail';
import OperatorTagAssign from '../../modules/operator/operatorTagAssign';
import LayoutRoute from '../layout/layout-route';
import LoginLayoutRoute from '../layout/login-layout-route';
import RoutesConstants from './routes-constants';
import MaterialTagAssign from '../../modules/bom-search/components/material-tag-assign';
import PartsSearch from '../../modules/bom-search/components/parts-search';

const Routes = () => {
  return (
    <React.Fragment>
      <Switch>
        <LoginLayoutRoute
          path={RoutesConstants.Login}
          component={Login}
        />
        <LayoutRoute
          path={RoutesConstants.AccountActivation}
          component={AccountActivation}
        />
        {findRouteAccess(ModuleType.UserManagement) && (
          <LayoutRoute
            path={RoutesConstants.UserManagement}
            component={BaseUser}
          />
        )}
        {findRouteAccess(ModuleType.TenantManagement) && (
          <LayoutRoute
            path={RoutesConstants.FactoryManagement}
            component={FactoryManagement}
          />
        )}
        {findRouteAccess(ModuleType.AIMSPortal) && (
          <LayoutRoute
            path={RoutesConstants.AIMSPortal}
            component={AIMSPortal}
          />
        )}
        {findRouteAccess(ModuleType.HolidayCalendar) && (
          <LayoutRoute
            path={RoutesConstants.HolidayCalendar}
            component={FactorySchedule}
          />
        )}
        {findRouteAccess(ModuleType.ProcessManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProcessManagement}
            component={ProcessManagement}
          />
        )}
        {findRouteAccess(ModuleType.ProcessTemplateManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProcessTemplateManagement}
            component={ProcessTemplateManagement}
          />
        )}
        {findRouteAccess(ModuleType.ProductManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProductManagement}
            component={ProductManagement}
          />
        )}
        {findRouteAccess(ModuleType.TeplarPrintTemplateManagement) && (
          <LayoutRoute
            path={RoutesConstants.TeplarPrintTemplateManagement}
            component={TeplarPrint}
          />
        )}
        {findRouteAccess(ModuleType.TrayManagement) && (
          <LayoutRoute
            path={RoutesConstants.TrayManagement}
            component={TrayManagement}
          />
        )}
        {findRouteAccess(ModuleType.GroupManagement) && (
          <LayoutRoute
            path={RoutesConstants.GroupManagement}
            component={GroupManagement}
          />
        )}
        {findRouteAccess(ModuleType.ActiveTrayManagement) && (
          <LayoutRoute
            path={RoutesConstants.ActiveTrayManagement}
            component={ActiveTrayManagement}
          />
        )}
        {findRouteAccess(ModuleType.ActiveTrayManagement) && (
          <LayoutRoute
            path={RoutesConstants.ProcessWiseChart}
            component={ProcessWiseChart}
          />
        )}
        {findRouteAccess(ModuleType.OrderViewDashboard) && (
          <LayoutRoute
            path={RoutesConstants.OrderTableView}
            component={OrderTableView}
          />
        )}
        {findRouteAccess(ModuleType.OrderViewDashboard) && (
          <LayoutRoute
            path={RoutesConstants.HKRDashboarData}
            component={HKRDashboardData}
          />
        )}
        {findRouteAccess(ModuleType.KishuManagement) && (
          <LayoutRoute
            path={RoutesConstants.KishuManagement}
            component={KishuManagement}
          />
        )}
        {findRouteAccess(ModuleType.BomSearch) && (
          <LayoutRoute
            path={RoutesConstants.BomSearch}
            component={BomSearch}
          />
        )}
        {findRouteAccess(ModuleType.BomSearch) && (
          <LayoutRoute
            path={RoutesConstants.MaterialTagAssign}
            component={MaterialTagAssign}
          />
        )}
        {findRouteAccess(ModuleType.BomSearch) && (
          <LayoutRoute
            path={RoutesConstants.PartsSearch}
            component={PartsSearch}
          />
        )}

        <LayoutRoute
          path={RoutesConstants.OperatorListDetail}
          component={OperatorListDetail}
        />

        <LayoutRoute
          path={`${RoutesConstants.OperatorAssignTask}/:taskId`}
          component={OperatorAssignTask}
        />
        {/* Start - Only for testing purpose */}
        <LayoutRoute
          path={`${RoutesConstants.OperatorAssignSpecialTask1}/:taskId`}
          component={OperatorTagAssign}
        />
        {/* End - Only for testing purpose */}

        <LayoutRoute
          path={`${RoutesConstants.OperatorAssignSpecialTask}/:taskId`}
          component={TagAssignRemove}
        />

        <LayoutRoute
          path={RoutesConstants.OperatorTagAssign}
          component={OperatorTagAssign}
        />
        <LayoutRoute
          path={RoutesConstants.OperatorImageAssign}
          component={OperatorImageAssign}
        />
        {findRouteAccess(ModuleType.FactoryAccess) && (
          <LayoutRoute
            path={RoutesConstants.FactoryAccess}
            component={FactoryAccess}
          />
        )}

        <LayoutRoute
          path={RoutesConstants.UserLogs}
          component={UserLogs}
        />
        <LayoutRoute
          path={RoutesConstants.DimensionTableFields}
          component={DimensionTableFields}
        />
        {findRouteAccess(ModuleType.CheckItemTemplate) && (
          <LayoutRoute
            path={RoutesConstants.CheckItemTemplate}
            component={CheckItemTemplate}
          />
        )}
        {findRouteAccess(ModuleType.TrayTagReassignment) && (
          <LayoutRoute
            path={RoutesConstants.TrayTagReassignment}
            component={TrayTagReassignment}
          />
        )}

        <Redirect to={redirectToDefaultRoute()} />
      </Switch>
    </React.Fragment>
  );
};

export default withRouter(observer(Routes));
